<template>
    <table-data-filter v-bind="$attrs"
        v-model="selectedVal"
        allString="所有支付方式"
        :title="'支付方式'"
        :width="200"
        :items="payments"
        :itemKeyName="itemKeyName"
        :itemKeyCode="itemKeyCode"
        @confirm="confirm" />
</template>

<script lang='ts'>
import { createComponent, ref, computed, watch } from '@vue/composition-api'
import TableDataFilter from '@/components/table_data_filter/table_data_filter.vue'

export default createComponent({
    props: {
        items: {
            type: Array,
            default: () => []
        },
        itemKeyName: {
            type: String,
            default: 'payment_name'
        },
        itemKeyCode: {
            type: String,
            default: 'id'
        }
    },

    setup(props, ctx) {
        const selectedVal = ref<string[]>([])

        const payments = computed(() => {
            return props.items.map((item: any) => ({ ...item, id: item.custom_payment_id == null ? `paymentType|${item.payment_type}` : `customPaymentId|${item.custom_payment_id}` }))
        })

        watch(() => payments.value, (newItems) => {
            selectedVal.value = newItems.map((item: any) => item[props.itemKeyCode])
        })

        function confirm() {
            const paymentList = selectedVal.value
                .filter((item: string) => item.startsWith('paymentType'))
                .map(item => +item.split('|')[1])
            const customPaymentIds = selectedVal.value
                .filter((item: string) => item.startsWith('customPaymentId'))
                .map(item => +item.split('|')[1])
            ctx.emit('confirm', {
                paymentList: paymentList,
                customPaymentIds: customPaymentIds
            })
        }

        return {
            selectedVal,
            payments,
            confirm
        }
    },
    components: {
        TableDataFilter
    }
})
</script>
